import { getPreloaderFnContext } from '@confluence/query-preloader-tools';

export const getCompanyHubSpaceKeyForSSR = async () => {
	const { activationId, cloudId } = await getPreloaderFnContext();

	if (activationId && cloudId) {
		return `~HUB-${cloudId}-${activationId}~`;
	}
};
